// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-limit-alert[data-v-41b38cea]{align-items:center;border-radius:16px;display:inline-flex;flex-direction:row;font-size:12px;gap:4px;letter-spacing:.2px;line-height:16px;padding:3px 10px 3px 4px}.order-limit-alert--none[data-v-41b38cea]{background:#3ca909;color:#fff}.order-limit-alert--moq[data-v-41b38cea],.order-limit-alert--mov[data-v-41b38cea]{background:#fff7df;color:#ca8706}.order-limit-alert i[data-v-41b38cea]{font-size:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
